module.exports = __webpack_public_path__ + "static/img/diy11.d8bbd1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purifiers/diy11.jpg
// module id = 13Ht
// module chunks = 1